module.exports = __webpack_public_path__ + "media/pichu.1c223789.wav";